export default __webpack_public_path__ + "static/media/Pathfinding-Visualizer-Project.b204849a.PNG";